import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Tip from './Tip';
import AnswerResult from './AnswerResult';
import useQuestionAnswer from '../../hooks/useQuestionAnswer';

export default function ValidatedImageSelection(props) {
  const { answer, result, change, check } = useQuestionAnswer(props.questionKey, []);
  const promptId = `${props.questionKey}-directions`;
  const resultId = `${props.questionKey}-result`;
  const valid = props.choices.filter(c => c.validChecked).map(c => c.label);
  return <Box sx={{ width: '100%', minWidth: 0 }}>
    <Typography id={promptId}>{props.directions || 'Select all correct images.'}</Typography>
    <Box role="group" aria-labelledby={promptId} aria-describedby={resultId} sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, my: 2 }}>
      {props.choices.map(choice => <Button type="button" key={choice.label} aria-pressed={answer.includes(choice.label)}
        onClick={() => change(answer.includes(choice.label) ? answer.filter(x => x !== choice.label) : [...answer, choice.label])}
        sx={{ border: '3px solid', borderColor: answer.includes(choice.label) ? 'primary.main' : 'text.secondary', maxWidth: '100%', flexDirection: 'column', gap: 1 }}>
        <img src={choice.imageFileName} alt={choice.imageAlt} style={{ maxHeight: 300, maxWidth: '100%', objectFit: 'contain' }} />
        <span aria-hidden="true">{answer.includes(choice.label) ? '✓ Selected' : 'Select'}</span>
      </Button>)}
    </Box>
    <Button type="button" variant="outlined" aria-describedby={promptId}
      onClick={() => check(answer.length === 0 ? null : answer.length === valid.length && valid.every(x => answer.includes(x)))}>Check</Button>
    <Tip tip={props.tip} describedBy={promptId} />
    <AnswerResult id={resultId} result={result} />
  </Box>;
}
